<template>
    <div class="ph-article-list">
        <div class="ph-article-list__background">
            <img src="../../assets/images/quiz-bgc.png" alt="kasanowa" />
        </div>
        <div class="ph-article-list__background-yellow kasanowa-desktop">
            <img src="../../assets/images/yellow-elipse.png" alt="kasanowa" />
        </div>
        <KLayoutWrapper>
            <template #default>
                <div>
                    <PaginatedItemList
                        :title="$t('articles.paginatedItemTitle')"
                        :description="$t('articles.paginatedItemDescription')"
                        :span-description="$t('articles.paginatedItemSpanDescription')"
                        :last-page="lastPage"
                        :loading="loading"
                        :items="items"
                        btnRedirect="articles-ph"
                        :change-page="changePageAction"
                    />
                </div>
            </template>
        </KLayoutWrapper>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import { toast } from 'vue3-toastify';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import ArticleApi from '@/api/v1/ArticleApi';
import type { IArticleResponse } from '@/models/ArticleModel';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import PaginatedItemList from '@/components/molecules/PaginatedItemList.vue';

const page = ref<number>(1);
const lastPage = ref<number>(1);
const itemsPerPage = ref<number>(4);
const items = ref<IArticleResponse[]>([]);
const loading = ref<boolean>(false);
const articleApi = new ArticleApi();
const { isAdmin, isAdminColian } = storeToRefs(useUserStore());
const articleList = async() => {
    loading.value = true;
    try {
        const result = await articleApi.articleList(
            page.value,
            itemsPerPage.value,
            null,
            null,
            isAdmin.value || isAdminColian.value,
            null,
        );
        if (!result.isSuccess) {
            toast.error(t('articles.toast.errorArticleList'));
            loading.value = false;
            return;
        }
        lastPage.value = result.payload.last_page;
        items.value = result.payload.data;
    } catch (e) {
        toast.error(t('articles.toast.errorArticleList'));
        loading.value = false;
        return;
    }
    loading.value = false;
};
articleList();

const changePageAction = (pageValue: number) => {
    page.value = pageValue;
    articleList();
};
</script>

<style scoped lang="scss">
.ph-article-list {
    width: 100%;
    position: relative;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__background-yellow {
        position: absolute;
        top: -30px;
        left: -40%;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            width: max-content;
            height: 100vh;
        }
    }
}
</style>
